export default "__VITE_ASSET__BxKrQYNO__"